import { useEffect, useState } from "react"
import { IPlayer, setQualityByVideoHeight, setQualityToAuto } from "../utils/shaka"
import { IVideoData } from "./useVideoData"

export function useQualitySettings(player: IPlayer | null, data: IVideoData | null) {
  const [quality, setQuality] = useState<number | "auto">("auto")

  useEffect(() => {
    if (quality === "auto") {
      setQualityToAuto(player)
    } else {
      setQualityByVideoHeight(player, quality)
    }
  }, [quality])

  const availableQualities = data
    ? [
        { label: "Auto", value: "auto" },
        ...data.videoFiles
          .filter(isVideoWithHeight)
          .filter(video => video.processingStatus !== "error")
          .sort((a, b) => b.height - a.height)
          .map(file => ({
            label: `${file.height}p`,
            value: file.height,
            loading: file.processingStatus !== "done" && file.processingStatus !== "error",
            disabled: file.processingStatus === "error",
          })),
      ]
    : []

  type IVideoFile = Exclude<typeof data, null>["videoFiles"][number]
  function isVideoWithHeight(
    file: IVideoFile,
  ): file is IVideoFile & { type: "video"; height: number } {
    return file.type === "video" && file.height !== null
  }

  return { currentQuality: quality, setQuality, availableQualities }
}
